import { render, staticRenderFns } from "./bookingdetail.vue?vue&type=template&id=69122314&scoped=true&"
import script from "./bookingdetail.vue?vue&type=script&lang=js&"
export * from "./bookingdetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69122314",
  null
  
)

export default component.exports